import { 
    LOOK_OUT_FOR_THE_LITTLE_GUYS_T_SHIRT, 
    MN_PIN,
    SOCKS,  
    Product
} from '../products';

const turtlCrossingPinRecos: Product[] = [
    LOOK_OUT_FOR_THE_LITTLE_GUYS_T_SHIRT,
    MN_PIN,
    SOCKS,   
];

export default turtlCrossingPinRecos;